import React from "react";
import { Modal } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { CreateNaturalPersonForm } from "./CreateNaturalPersonForm";
import { CreateLegalPersonForm } from "./CreateLegalPersonForm";
var CreatePersonInlineModal = function (_a) {
    var open = _a.open, personType = _a.personType, onClose = _a.onClose, onCreated = _a.onCreated;
    var formatMessage = useIntl().formatMessage;
    var isNatural = personType === "natural";
    var label = formatMessage({
        id: isNatural
            ? "ui-br-agency.title.contributions.form.createPerson.modal.title"
            : "ui-br-agency.title.contributions.form.createLegalPerson.modal.title",
    });
    return (React.createElement(Modal, { open: open, onClose: onClose, label: label, size: "medium", dismissible: true }, open &&
        (isNatural ? (React.createElement(CreateNaturalPersonForm, { onCreated: onCreated, onCancel: onClose })) : (React.createElement(CreateLegalPersonForm, { onCreated: onCreated, onCancel: onClose })))));
};
export { CreatePersonInlineModal };
